var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrderProcessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#FFB8F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3971 7.61374C17.0845 7.29287 16.6218 7.17334 16.1904 7.29917L6.13 10.2247C5.67481 10.3512 5.35218 10.7142 5.26527 11.1753C5.17648 11.6447 5.48661 12.2405 5.89178 12.4896L9.03744 14.423C9.36007 14.6212 9.77649 14.5715 10.0435 14.3022L13.6456 10.6777C13.8269 10.4889 14.127 10.4889 14.3083 10.6777C14.4897 10.8601 14.4897 11.1558 14.3083 11.3446L10.7 14.9697C10.4324 15.2384 10.3824 15.6568 10.5793 15.9814L12.5014 19.1586C12.7264 19.5361 13.1141 19.75 13.5393 19.75C13.5893 19.75 13.6456 19.75 13.6956 19.7437C14.1833 19.6808 14.571 19.3473 14.7148 18.8755L17.6972 8.82799C17.8285 8.40017 17.7097 7.9346 17.3971 7.61374Z",
    fill: "#AC009B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderProcessIcon);
export default __webpack_public_path__ + "static/media/order-process-icon.f43074d04f596b8cdc20bff17958da04.svg";
export { ForwardRef as ReactComponent };